import isNil from 'lodash/isNil';

import type { AutocompleteAddressApiType } from '../types/ApiResponseTypes';

type AutocompleteAddressUIType = {
  city: string | null;
  name: string | null;
  propertyId: string | null;
  state: string | null;
  street: string | null;
};

class AutocompleteAddress {
  city: string | null;
  name: string | null;
  propertyId: string | null;
  state: string | null;
  street: string | null;

  constructor(res: AutocompleteAddressApiType | AutocompleteAddressUIType = <AutocompleteAddressApiType>{}) {
    if (res) {
      this.city = !isNil(res.city) ? res.city : null;
      this.name = !isNil(res.name) ? res.name : null;
      this.propertyId = !isNil(res.propertyId) ? res.propertyId : null;
      this.state = !isNil(res.state) ? res.state : null;
      this.street = !isNil(res.street) ? res.street : null;
    } else {
      this.city = null;
      this.name = null;
      this.propertyId = null;
      this.state = null;
      this.street = null;
    }
  }
}

export default AutocompleteAddress;
